<app-loader *ngIf="isLoading else mainPage"></app-loader>

<ng-template #mainPage>
  <div class="container page-component-container grid-lg">

    <div *ngIf="!errorCallout" class="columns">
      <div class="column col-12">
        <h4 class="underline">{{ 'lang_featured_events' | translate | uppercase }}</h4>

        <!-- HIGHLIGHTED EVENTS -->
        <ng-container *ngIf="highlightedPrograms.length > 0">
          <div class="columns event-columns" [@cardRevealAnimation]>
            <div *ngFor="let event of highlightedPrograms; trackBy: trackByFn" class="column col-4 col-md-6 col-sm-12 animate">
              <event-card [event]="event" (onBuyTicket)="onBuyTicket($event)" (hasNoTicket)="onHasNoTicket(event.id)"></event-card>
            </div>
          </div>
        </ng-container>

        <!-- EMPTY CALLOUT -->
        <div class="columns">
          <div class="column col-12" *ngIf="highlightedPrograms.length === 0">
            <app-callout [callout]="emptyListCallout"></app-callout>
          </div>
        </div>

        <div class="columns" [@cardRevealAnimation]>

          <div class="column animate">
            <h4 class="underline">{{ 'our_events' | translate | uppercase }}</h4>
            <div class="columns event-columns">

              <!-- OTHER EVENTS -->
              <ng-container *ngIf="eventList.length > 0">
                <div *ngFor="let event of eventList; trackBy: trackByFn" class="column col-6 col-md-6 col-sm-12 z-index-0">
                  <event-card [event]="event" [partnerName]="partnerName" (onBuyTicket)="onBuyTicket($event)" (hasNoTicket)="onHasNoTicket(event.id)"></event-card>
                </div>

                <!-- ALL PROGRAMS BUTTON -->
                <div class="column col-12 text-center text-bold all-programs-btn-container">
                  <a [routerLink]="['event']" class="btn btn-primary">{{ 'label_all_programs' | translate }}</a>
                </div>
              </ng-container>

              <!-- EMPTY CALLOUT -->
              <div class="column col-12" *ngIf="eventList.length === 0">
                <app-callout [callout]="emptyListCallout"></app-callout>
              </div>

            </div>
          </div>

          <div class="column col-4 col-md-12 animate" *ngIf="(showVenueMap || displayCalendar) && eventList.length > 0">
            <aside>
              <!-- CALENDAR -->
              <ng-container *ngIf="displayCalendar && (calendarEventList?.length || isLoadingCalendar)">
                <h4 class="underline">{{ 'label_calendar' | translate }}</h4>
                <event-calendar [isLoading]="isLoadingCalendar" [events]="calendarEventList" [inline]="true" [selectionMode]="'multiple'"></event-calendar>
              </ng-container>

              <!-- VENUES -->
              <app-venue-map *ngIf="showVenueMap"></app-venue-map>
            </aside>
          </div>

        </div>

      </div>
    </div>

    <div *ngIf="errorCallout" class="columns">
      <div class="column col-12">
        <app-callout [callout]="errorCallout"></app-callout>
      </div>
    </div>

  </div>

  <!-- TICKET REQUIRED MODAL -->
  <app-custom-modal [title]="'ticket_required_warning'" [isOpen]="isModalOpen" (onClose)="isModalOpen = false">
    <p modal-body class="text-dark" [innerHTML]="'label_error_user_doesnt_have_ticket_for_event_formatted' | translate"></p>
    <button modal-footer type="button" class="btn btn-primary" (click)="isModalOpen = false; onBuyTicket(this.selectedEventId)">{{ 'stemx_public_tickets' | translate }}</button>
  </app-custom-modal>

  <app-custom-sidebar class="text-white" [isOpen]="sideBarEventId" (onClose)="closeSidebar()">
    <app-add-to-cart [eventId]="sideBarEventId"></app-add-to-cart>
  </app-custom-sidebar>

</ng-template>
